/**
 * Calendar
 */
export const Calendar = (function () {

  var init =  function () {  
      Calendar.load()
      addEventListeners();
  }

  var load = function() {
    // Get the Twig Events data
    var element = document.getElementById(`myds-calendar`);

    if( element ){
      var eventsData = element.getAttribute("data-items");
      // Get the current date to be the date that the calendar first shows when loading - Returns yyyy-mm-dd format
      var initialDate = new Date();
      eventsData = JSON.parse(eventsData);
    }

    // Resets the modal form when closed
    $('#add-event-modal').on('hidden.bs.modal', function () {
      $(this).find('form').trigger('reset');
    })

    var desktopConfig = {
      plugins: [ dayGridPlugin, bootstrapPlugin, interactionPlugin],
      headerToolbar: {
        center: 'title',
        left: 'prev,next,today',
        right: 'dayGridMonth,dayGridDay,dayGridWeek',
      },
      buttonText: {
        prev: '<',
        next: '>',
        today: 'Today',
        day: 'Day',
        week: 'Week',
        month: 'Month'
      },
      themeSystem: 'bootstrap',
      initialView: 'dayGridMonth',
      initialDate: initialDate,
      height: 'auto',
      dayMaxEvents: 2,
      events: eventsData,
      eventTimeFormat: { 
        hour: 'numeric',
        minute: '2-digit',
        meridiem: false
      },
      displayEventTime : true,
      dateClick: function(info) {
        // Displays the add event modal when clicking on a date in the calendar
        showAddEventModal(info);
      },
      eventClick: function(info){
        // Displays the edit event modal when clicking on calendar Event
        showEditEventModal(info);
      },
  }
    var mobileConfig = {
      
        plugins: [ dayGridPlugin, bootstrapPlugin, interactionPlugin],
        headerToolbar: {
          left: 'title',
          right: 'dayGridMonth,dayGridDay,dayGridWeek',
        },
        footerToolbar: {
          right: 'today',
          left: 'prev,next'
        },
        buttonText: {
          prev: '<',
          next: '>',
          today: 'Today',
          day: 'Day',
          week: 'Week',
          month: 'Month'
        },
        fixedWeekCount: false,
        themeSystem: 'bootstrap',
        initialView: 'dayGridMonth',
        initialDate: initialDate,
        dayMaxEvents: 2,
        height: (window.screen.height / 100) * 72,
        events: eventsData,
        eventTimeFormat: { 
          hour: 'numeric',
          minute: '2-digit',
          meridiem: false
        },
        displayEventTime : true,
        dateClick: function(info) {
          // Displays the add event modal when clicking on a date in the calendar
          showAddEventModal(info);
      },
      eventClick: function(info){
        // Displays the edit event modal when clicking on calendar Event
        showEditEventModal(info);
      },
    }

    // Instatiate the Full Callendar - if the element exists
    if( element ){
      // Change the config depending on device
      var config = window.matchMedia("(max-width: 767px)").matches ? mobileConfig : desktopConfig;
      var calendar = new FullCalendar(element, config );
      this.calendar = calendar
      calendar.render(); 
    }
  }

   /**
     * EVENT LISTENERS
     */
    function addEventListeners() {
      $('#add-calendar-event').on('submit', function(event) {
        event.preventDefault();

        // Checks that the end date is not earlier than the start date
        var start_time = $('#start-time').val();
        var end_time = $('#end-time').val();
        if(checkTime(start_time, end_time)) {
          saveCalendarEvent();
        }
      })

      $('#delete-calendar-event').on('click', function() {
        deleteCalendarEvent();
      })

      $('#edit-calendar-event').on('submit', function(event) {
        event.preventDefault();

        // Checks that the end date is not earlier than the start date
        var start_time = $('#edit-start-time').val();
        var end_time = $('#edit-end-time').val();
        if(checkTime(start_time, end_time)){
          editCalendarEvent();
        }
      })
    }

    /**
    * HTTP FUNCTIONS
    */
     function saveCalendarEvent() {
      // Get form data
      var form = getInputs();

      // Run function to change format of event into pds format
      var pdsForm = pdsFormat(form);

      // Post event to be added to users pds
       var promise = PDS.pds.post('ds_events', pdsForm);
       promise.then(function (response) {
         // Add event to calendar
         form.id = response.last_insert_id;
         Calendar.calendar.addEvent(form);
         Calendar.calendar.render();
         $("#add-event-modal").modal("hide");
       });
       promise.fail(function (response) {
         console.log('fail');
       });
     }

     function deleteCalendarEvent() {
      // Get the event_id to be deleted
      var event_id = $('#edit-event-modal').attr('data-event-id');

      var promise = PDS.pds.delete('ds_events', event_id);
        promise.then(function (response){
          var event = Calendar.calendar.getEventById(event_id);
          event.remove();
          $("#edit-event-modal").modal("hide");
        });
        promise.fail(function (response) {
          console.log('fail');
        });
     }

     function editCalendarEvent() {
      // Get form data
      var form = getInputsToEdit();

      // Run function to change format of event into pds format
      var pdsForm = pdsFormat(form);

      // Get the event_id to be updated
      var event_id = $('#edit-event-modal').attr('data-event-id');

      // Post event to be added to users pds
       var promise = PDS.pds.update('ds_events', pdsForm, event_id);
       promise.then(function (response) {
         // Add event to calendar
         var event = Calendar.calendar.getEventById(event_id);
         event.remove();
         form.id = response.last_insert_id;
         Calendar.calendar.addEvent(form);
         Calendar.calendar.render();
         $("#edit-event-modal").modal("hide");
       });
       promise.fail(function (response) {
         console.log('fail');
       });
     }

    /**
     * HELPER FUNCTIONS
     */

    function getInputs() { 
      // Get the values from the form 
      var start_date = $('#start-date').val(); 
      var end_date = $('#end-date').val();
      var start_time = start_date + " " + $('#start-time').val();
      var end_time = end_date + " " + $('#end-time').val();
      var title = $('#title').val(); 
      var organiser = $('#organiser').val();
      var location = $('#location').val();
      var description = $('#description').val(); 
      return { 
        'title' : title, 
        'start' : start_time, 
        'end' : end_time,
        'allDay' : false,
        'description' : description,
        'organiser' : organiser,
        'location' : location
      } 
    }

    function getInputsToEdit() {
      // Get the values from the form 
      var start_date = $('#edit-start-date').val(); 
      var end_date = $('#edit-end-date').val();
      var start_time = start_date + " " + $('#edit-start-time').val();
      var end_time = end_date + " " + $('#edit-end-time').val();
      var title = $('#edit-title').val(); 
      var organiser = $('#edit-organiser').val();
      var location = $('#edit-location').val();
      var description = $('#edit-description').val(); 
      return { 
        'title' : title, 
        'start' : start_time, 
        'end' : end_time,
        'allDay' : false,
        'description' : description,
        'organiser' : organiser,
        'location' : location
      } 
    }

    function pdsFormat(frontEndFormat) { 
      var title = frontEndFormat['title'];
      var start_time = frontEndFormat['start'];
      var end_time = frontEndFormat['end'];
      var description = frontEndFormat['description']; 
      var organiser = frontEndFormat['organiser'];
      var location = frontEndFormat['location'];

      // Convert start and end times to timestamp 
      var start_timestamp = Date.parse(start_time) / 1000; 
      var end_timestamp = Date.parse(end_time) / 1000; 

      return { 
        'start_timestamp' : start_timestamp, 
        'end_timestamp' : end_timestamp, 
        'title' : title, 
        'description' : description,
        'organiser' : organiser,
        'location' : location
      } 
    }

    function checkTime(start_time, end_time) {
      if(end_time < start_time){
        Util.toggleAlert('.alert', "End time has to be after start time.", 'alert-warning');
        return false;
      }
      return true;
    }

    function showAddEventModal(info){
      $('.fc-popover').hide();
      $('.time-error').remove();
      $("#add-event-modal").modal("show");
      $("#start-date").val(info.dateStr);
      $('#end-date').val(info.dateStr);
    }

    function showEditEventModal(info){
      // Shows the edit modal when clicking on an event
      $('.fc-popover').hide();
      $('.time_error').remove();
      $('#edit-event-modal').modal('show');
      $('#edit-event-modal').attr('data-event-id', info.event.id);

      // Gets the event's data and time for the one selected and formats it correctly to be added to the input fields
      var start_date = info.event.start;
      var end_date = info.event.end;
      // Format date to yyyy-mm-dd
      var date_input = start_date.toISOString().split('T')[0];
      // Get time from the date object
      var start_time = start_date.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'}).split(' ')[0];
      var end_time = info.event.end;
      
      // If the end time is the same as the start time then it will be set as null, this fixes that by setting the end time to be the same as the start time
      if(end_time == null){
        end_time = start_time;
        $('#edit-start-date').val(date_input);
        $('#edit-end-date').val(date_input);
      } else {
        $('#edit-start-date').val(date_input);
        end_time = end_time.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit',}).split(' ')[0];
        date_input = end_date.toISOString().split('T')[0];
        $('#edit-end-date').val(date_input);
      }

      // Sets the input fields in the modal to be the data from the clicked event
      $('#edit-start-time').val(start_time);
      $('#edit-end-time').val(end_time);
      $('#edit-title').val(info.event.title);
      $('#edit-organiser').val(info.event.extendedProps.organiser);
      $('#edit-location').val(info.event.extendedProps.location);
      $('#edit-description').val(info.event.extendedProps.description);
    }
    
  var render = function(){
    this.calendar.render();
  }

  return {
    init: init,
    load : load,
    render : render
  }

}());